<template>


</template>


<script>
    import MarqueeText from 'vue-marquee-text-component'
    import customButton from 'components/button/customButton.vue'

    export default {
        components: {
            MarqueeText,
            customButton
        },
        data() {
            return {
                paused: false,
            };
        },
        methods: {}
    };
</script>

<style rel="stylesheet/scss" lang="scss" type="text/css" scoped>
    .marquee-item {
        height: 59px;

        @screen lg {
            height:73px;
        }

        @screen xl {
            height: 114px;
        }

    }

    .marquee-text-content {
        margin-top:0;

        @screen lg {
            margin-top: -9px;
        }
        @screen xl {
            margin-top: -5px;
        }
    }
</style>